import { PayloadAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import { reusableGridSort } from '../grid/reusable-grid.function';

import { FocusSelectorSortMetrics } from './metric-sort.action';

export function focusSelectorSortMetricsReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSortMetrics>,
): FocusSelectorState {
    const { column } = action.payload;
    const { sortDefs, defaultSortDefs } = state.metricSelectionGrid;
    const nextSortDefs = reusableGridSort(column, sortDefs, defaultSortDefs);

    return {
        ...state,

        metricSelectionGrid: {
            ...state.metricSelectionGrid,
            sortDefs: nextSortDefs,
        },
    };
}
